import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from '@material-ui/core';
import AppLoader from '../../basic/AppLoader';
import AppTable from '../../basic/AppTable';
import { filterTypes } from '../../basic/AdvancedFilters';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import { parseDate } from '../consents/ConsentsTable';

const tableColumns = [
  { id: 1, label: 'Serial', field: 'registration_kit.serial_number_id.serial', noSort: true },
  { id: 2, label: 'Patient First Name', field: 'source.name' },
  { id: 3, label: 'Patient Last Name', field: 'source.family_name' },
  { id: 4, label: 'Patient E-mail', field: 'source.email' },
  { id: 5, label: 'Doctor First Name', field: 'metadata.firstName', noSort: true },
  { id: 6, label: 'Doctor Last Name', field: 'metadata.lastName', noSort: true },
  { id: 7, label: 'Doctor E-mail', field: 'metadata.email', noSort: true },
  { id: 71, label: 'Doctor Business Number', field: 'metadata.businessNumber', noSort: true },
  { id: 8, label: 'Invitation status', field: 'status' },
  { id: 9,
    label: 'Report status',
    field: 'registration_kit.pdf_available',
    customRenderer({ row }) {
      return (
        <div>
          {
            true === row.registration_kit?.pdf_available && (
              <DoneIcon style={ { color: '#93c120' } } />
            )
          }
          {
            true !== row.registration_kit?.pdf_available && (
              <CloseIcon style={ { color: 'red' } } />
            )
          }
        </div>
      );
    } },
  { id: 10,
    label: 'Registration done date',
    field: 'registration_kit.metadata.registrationDoneDate',
    noSort: true,
    customRenderer({ row }) {
      return (
        <div>
          { parseDate(row.registration_kit?.metadata?.registrationDoneDate) || '' }
        </div>
      );
    } },
];

const DoctorKitCorrelationTable = () => {
  const [ filterQuery, setFilterQuery ] = useState({});

  const {
    items: doctors,
    itemsLoading: doctorsLoading,
    pagination,
  } = useItems(CollectionKeys.INVITATIONS, { filterQuery });

  const {
    items: allDoctors,
    itemsLoading: allDoctorsLoading,
  } = useItems(CollectionKeys.INVITATIONS, { filterQuery: {
    ...filterQuery,
    _limit: -1,
  } });

  if (doctorsLoading || allDoctorsLoading) {
    return <AppLoader />;
  }

  const downloadData = (theDoctors) => {
    if (null == theDoctors) {
      return;
    }

    const data = theDoctors.map((doctor) => {
      const obj = {
        Serial: doctor?.registration_kit?.serial_number_id?.serial || '',
        'Patient First Name': doctor?.source?.name || '',
        'Patient Last Name': doctor?.source?.family_name || '',
        'Patient Email': doctor?.source?.email || '',
        'Doctor First Name': doctor?.metadata?.firstName || '',
        'Doctor Last Name': doctor?.metadata?.lastName || '',
        'Doctor Email': doctor?.metadata?.email || '',
        'Doctor Business Number': doctor?.metadata?.businessNumber || '',
        'Doctor Specialty': doctor?.metadata?.specialty || '',
        'Invitation status': doctor?.status || '',
        'Report status': `${ true === doctor?.registration_kit?.pdf_available }`,
        'Registration done date': parseDate(doctor?.registration_kit?.metadata?.registrationDoneDate) || '',
      };

      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = fitToColumn(data);

    function fitToColumn(arrayOfArray) {
      return Object.keys(arrayOfArray[0]).map((key) => {
        return { wch: key.length };
      });
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Doctor-Kit-Correlation.xlsx');
  };

  return (
    <>
      <Button
        style={ { marginRight: '10px' } }
        onClick={ () => { downloadData(doctors); } }
        variant='contained'
      >
        Download
      </Button>
      <Button
        style={ { marginRight: '10px' } }
        onClick={ () => { downloadData(allDoctors); } }
        variant='contained'
      >
        Download All
      </Button>
      <AppTable
        columns={ tableColumns }
        data={ doctors }
        loading={ doctorsLoading }
        paginationProps={ pagination }
        advancedFiltersProps={ {
          properties: [
            {
              value: 'registration_kit.serial_number_id.serial',
              label: 'Serial',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'source.name',
              label: 'Patient First Name',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'source.family_name',
              label: 'Patient Last Name',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'source.email',
              label: 'Patient E-mail',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'status',
              label: 'Invitation status',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'registration_kit.pdf_available',
              label: 'Report status',
              type: filterTypes.CATEGORY,
              options: [
                { value: false, label: 'FALSE' },
                { value: true, label: 'TRUE' },
              ],
            },
            {
              value: 'registration_kit.thematic_package.thematic_category_id.name',
              label: 'Thematic Package',
              type: filterTypes.CATEGORY,
              options: [
                { value: '3-in-1', label: '3-in-1' },
                { value: 'Biological Age', label: 'Biological Age' },
                { value: 'Cardio Health', label: 'Cardio Health' },
                { value: 'NutriGenetix', label: 'NutriGenetix' },
                { value: 'Nutrition', label: 'Nutrition' },
                { value: 'PGx', label: 'PGx' },
                { value: 'Sports', label: 'Sports' },
                { value: 'Vitamins', label: 'Vitamins' },
              ],
            },
          ],
          initialAndFilterOptions: [],
          onQueryChange: setFilterQuery,
        } }
      />
    </>
  );
};

export default DoctorKitCorrelationTable;
